import { Component, OnInit } from '@angular/core';
import { Editor, toHTML } from 'ngx-editor';
import { MipsService } from 'src/app/services/mips.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-mips-interpretations',
  templateUrl: './mips-interpretations.component.html',
  styles: [
  ]
})
export class MipsInterpretationsComponent implements OnInit {

  public scales = [];
  public cogn = true;
  public motiv = true;
  public interp = true;
  public validez = true;
  public interpretations = [];
  public selectedScale = {
    scale:"",
    ranks:[]
  }
  public rank = {
    name:"",
    min:0,
    max:0,
    text:"",
  }

  public editor:Editor;
  public html;

  constructor(
    private mipsService:MipsService
  ) { }

  ngOnInit(): void {
    this.editor = new Editor();
    this.mipsService.getScales().subscribe(
      resp=>{
        this.scales = resp;
      },
      err=>console.log(err)
    )
    this.mipsService.getInterpretations().subscribe(
      resp=>{
        this.interpretations = resp;
      },
      err=>console.log(err)
    )
  }

  addRank(){
    let i = 0;
    let founded = false;
    for (let r of this.selectedScale.ranks){
      if (this.rank.name == r.name){
        founded = true;
      }else if(!founded) i++;
    }
    var html;
    if (this.html.type == "doc"){
      html = toHTML(this.html);
    }else{
      html = this.html;
    }
    this.rank.text = html;

    if (!founded) this.selectedScale.ranks.push(this.rank);
    else this.selectedScale.ranks[i] = this.rank;
    this.html="";
    this.rank = {
      name:"",
      min:0,
      max:0,
      text:"",
    }
  }

  update(){
    if(this.selectedScale.scale){
      let founded = false;
      let i = 0;
      for (let interpretation of this.interpretations){
        if (interpretation.scale == this.selectedScale.scale){
          founded = true;
        }else if (!founded) i++;
      }
      if (!founded) {
        this.interpretations.push(this.selectedScale)
      }
      else this.interpretations[i] = this.selectedScale;
      this.mipsService.updateScale(this.selectedScale).subscribe(
        resp=>{
          Swal.fire("Escala actualizada").then(
            resp=>{
              // this.selectedScale = {
              //   scale:"",
              //   ranks:[]
              // }
              // this.editor.destroy();
              // this.editor = new Editor();
              this.html="";
            }
          );
        },
        err=>console.log(err)
      )
      // this.selectedScale = {
      //   scale:"",
      //   ranks:[]
      // }
    }
  }

  changeScale(scale){
    this.html = "";
    this.selectedScale = {
      scale:"",
      ranks:[]
    }
    let founded = false;
    this.interpretations.map(
      interpretation=>{
        if (interpretation.scale == scale) {
          founded = true
          this.selectedScale = interpretation;
        }
      }
    )
    if (!founded) this.selectedScale.scale = scale;
  }

  editRank(r){
    this.rank = r;
    this.html = r.text;
  }

  deleteRank(i){
    this.selectedScale.ranks.splice(i,1);
  }

}
